/* eslint-disable import/prefer-default-export */
import BaseFeature from '@appblocks/codegeneration/BaseFeature';
import ProjectConfiguration from '@appblocks/codegeneration/ProjectConfiguration';
import {
    CodeBlock,
    BlockType,
    SettingType,
    Define,
    ValidationMessageType,
    ValidationMessage,
    SettingState,
    Setting,
    TibboDataType,
} from '@appblocks/codegeneration/types';
import BaseNode from '@appblocks/codegeneration/Nodes/BaseNode';
import NodePort from '@appblocks/codegeneration/Nodes/NodePort';
import NodeParameter from '@appblocks/codegeneration/Nodes/NodeParameter';


export const getCodeBlocks = (feature: BaseFeature): CodeBlock[] => {
    const blocks: Array<CodeBlock> = [];
    const topic_name = feature.project.parseCodeExpression(feature.getSettingValue('TOPIC_NAME'), [], TibboDataType.STRING);
    const NAME = feature.getSettingValue('NAME');
    const QOS = feature.getSettingValue('QOS');
    const ID = feature.getID();

    const topicNameIdentifier = NAME.replace(/ /g, '_').toUpperCase();

    blocks.push({
        location: 'VARIABLE_DECLARATIONS',
        blockType: BlockType.CODE,
        template: `
mqtt_topic_${topicNameIdentifier} = ${topic_name}`,
    });

    blocks.push({
        location: 'callback_mqtt_connect_ok',
        blockType: BlockType.CODE,
        template: `MQTTClientInstance.subscribe(mqtt_topic_${topicNameIdentifier})`,
    });

    blocks.push({
        location: 'callback_mqtt_notif',
        blockType: BlockType.CODE,
        id: `mqtt_notif_${topicNameIdentifier}`,
        template: `
    if mqtt_topic_match(mqtt_topic_${topicNameIdentifier},topic):
        #****mqtt_notif_${feature.getSettingValue('TOPIC_NAME', true)}****#
        pass`,
    });
    return blocks;
};
